import { createFileRoute } from "@tanstack/react-router";

import { SkuStoreAssociationsPage } from "@/features/SKUStore/SkuStoreAssociationsPage";

export const Route = createFileRoute(
  "/_auth/sku-store/$siteId/$skuId/associations",
)({
  component: SkuStoreAssociationsPage,
});
